<div class="modal">
  <div class="modal__header">
    <custom-app-bar
      [hasCloseButton]="true"
      [hasSafeArea]="false"
      [closeButtonReturnToThePreviousPage]="false"
      (onClickCloseButton)="closeModal()"
    ></custom-app-bar>

    <h2 class="modal__title">{{ "no_stock.title_desktop" | translate }}</h2>
  </div>

  <div class="modal__content">
    <div class="product__list">
      <ep-product-list-tile
        *ngFor="let product of products"
        [product]="product"
        [hasAddToListButton]="false"
        [hasDeleteButton]="false"
        [hasAddToCartButton]="false"
      >
      </ep-product-list-tile>
    </div>

    <div class="similar-products" *ngIf="firstThreeProductsCodes.length > 0">
      <p class="similar-products__title">
        {{ "no_stock.similar_products_desktop" | translate }}
      </p>

      <ep-similar-products
        [productsCodes]="firstThreeProductsCodes"
        [displayTitle]="false"
        [hasAddToListButton]="false"
        [shownProducts]="10"
      ></ep-similar-products>
    </div>

    <div class="buttons">
      <button
        customButton
        size="large"
        expand="block"
        [routerLink]="['/', routesNames.cartDetail] | localize"
        (click)="closeModal()"
      >
        {{ "no_stock.go_to_cart" | translate }}
      </button>
      <button
        customButton
        appearance="ghost"
        size="large"
        expand="block"
        (click)="closeModal()"
      >
        {{ "no_stock.continue" | translate }}
      </button>
    </div>
  </div>
</div>
